import { es, enUS, enGB } from 'date-fns/locale'

export function localeMap(locale) {
  const supportedLocales = {
    es_us: es,
    en_gb: enGB,
    en: enUS,
    es: es,
  }
  return supportedLocales[locale] || enUS
}
